import React from "react";
import { useSelector } from "react-redux";
import AllRequestList from "../components/allRequests";
import { useParams } from "react-router-dom";

const AllRequests: React.FC = () => {
  const userData = useSelector((state: any) => state.formConfig.user);
  const { id } = useParams();
  const handleYearChange = (year: string) => {
    console.log("Fetch data for year:", year);
   
  };

  return (
    <div style={{background:'rgb(236, 239, 241)',padding:30, paddingTop:100, paddingBottom:80}}>
        
      <AllRequestList activeTab={id} onYearChange={handleYearChange} showHeaderActions={true} userId={userData.userId} />
    
    </div>
  );
};

export default AllRequests;
